module.exports = require('../impls/$bisect/bisect.js').__bisect;